// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalWrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1040;
  background: rgba(88, 88, 88, 0.7); }
  .ModalWrapper .Modal {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: #f9e5a9;
    border-radius: 12px;
    border: 3px solid;
    position: relative;
    padding: 3rem;
    box-sizing: border-box;
    max-width: calc(100vw - 2rem);
    max-height: calc(100vh - 2rem); }
  .ModalWrapper .close-modal {
    position: absolute;
    right: 1rem;
    top: 1rem;
    font-size: 2rem;
    background: none;
    border: none;
    font-weight: bold;
    cursor: pointer;
    font-family: inherit; }
  .ModalWrapper .modal-title {
    font-size: 2.5rem;
    text-align: center;
    margin-top: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/library/Modal.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iCAAiC,EAAA;EARnC;IAWI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBChBgB;IDiBhB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B,EAAA;EArBlC;IAyBI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oBAAoB,EAAA;EAjCxB;IAqCI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa,EAAA","sourcesContent":["@import \"./../../style/colors\";\n\n.ModalWrapper {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1040;\n  background: rgba(88, 88, 88, 0.7);\n\n  .Modal {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    background: $background;\n    border-radius: 12px;\n    border: 3px solid;\n    position: relative;\n    padding: 3rem;\n    box-sizing: border-box;\n    max-width: calc(100vw - 2rem);\n    max-height: calc(100vh - 2rem);\n  }\n\n  .close-modal {\n    position: absolute;\n    right: 1rem;\n    top: 1rem;\n    font-size: 2rem;\n    background: none;\n    border: none;\n    font-weight: bold;\n    cursor: pointer;\n    font-family: inherit;\n  }\n\n  .modal-title {\n    font-size: 2.5rem;\n    text-align: center;\n    margin-top: 0;\n  }\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
